import {select} from 'd3-selection';
import {className} from '../../modules/util';
import spectrum from  '../../modules/spectrum';

function renderSpectrum() {

  let legendToggle = this.legend();
  if (!legendToggle) return;
  
  let field = this.__execs__.field;
  let x,y,width, height;
  let offset =  this.offset();
  //FIXME: 현재 legend 하단에만 가능
  if (legendToggle.orient === 'bottom') {
    x = 0;
    y = this.innerSize().height  + offset.bottom - this.margin().bottom - legendToggle.thickness;
    width = this.innerSize().width;
    height = legendToggle.thickness;
  }
  
  let colorScale = this.scale().color;
  let legendObj = spectrum().scale(colorScale)
    .field(field.color.field)
    .x(x).y(y)
    .width(width).height(height);
  this.__execs__.canvas.selectAll(this.nodeName() + '.point')
    .on('mouseenter.spectrum', d => {
      legendObj.show(d.data.value)
    })
    .on('mouseleave.spectrum', () => legendObj.hide());
  this.__execs__.legend = legendObj;

  let canvas = this.__execs__.canvas;
  let spectrumSel = canvas.selectAll(className('spectrum', true))
    .data([legendObj]);
  spectrumSel.exit().remove();
  spectrumSel.enter().append('g')
    .attr('class', className('spectrum'))
    .merge(spectrumSel)
    .each(function(d) {
      d.render(select(this));
    });
  return this;
}

export default renderSpectrum;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/renderSpectrum.js